import axios from 'axios'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  ResetPassword,
  SendUserOtp,
  StudentLoginAPI,
} from '../../AllAPI/StudentAPI'
import { Modal } from 'antd'

const style = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=DM+Sans:wght@300;400;500;600&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --gold: #ffc107;
    --gold-deep: #e6a800;
    --gold-light: #fff3cd;
    --gold-pale: #fffbec;
    --dark: #1a1200;
    --dark-2: #2b1f00;
    --dark-3: #3d2e00;
    --text: #1a1200;
    --text-muted: #7a6000;
    --white: #ffffff;
    --shadow: 0 8px 40px rgba(255,193,7,0.18);
    --radius: 18px;
  }

  body {
    font-family: 'DM Sans', sans-serif;
    // background: var(--gold-pale);
    background: var(--gold-pale);
    min-height: 100vh;
  }

  .page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    // background: var(--gold-pale);
    position: relative;
    overflow: hidden;
  }

  /* Decorative background */
  .page::before {
    content: '';
    position: fixed;
    top: -120px; right: -120px;
    width: 480px; height: 480px;
    border-radius: 50%;
    // background: radial-gradient(circle, rgba(255,193,7,0.22) 0%, transparent 70%);
    pointer-events: none;
    z-index: 0;
  }
  .page::after {
    content: '';
    position: fixed;
    bottom: -80px; left: -80px;
    width: 380px; height: 380px;
    border-radius: 50%;
    // background: radial-gradient(circle, rgba(255,193,7,0.13) 0%, transparent 70%);
    pointer-events: none;
    z-index: 0;
  }

  /* ─── HEADER ─── */
  .header {
    position: relative;
    z-index: 10;
    background: linear-gradient(135deg, var(#242443) 0%, var(#162e29) 60%, var(#162e29) 100%);
    // linear-gradient(115deg, #242443, #162e29)
    padding: 28px 40px 24px;
    display: flex;
    align-items: center;
    gap: 22px;
    box-shadow: 0 4px 32px rgba(255,193,7,0.18);
  }

  .logo-ring {
    width: 72px; height: 72px;
    border-radius: 50%;
    border: 3px solid var(--gold);
    display: flex; align-items: center; justify-content: center;
    background: linear-gradient(145deg, var(--dark-2), var(--dark-3));
    box-shadow: 0 0 0 6px rgba(255,193,7,0.12), 0 4px 20px rgba(0,0,0,0.4);
    flex-shrink: 0;
    position: relative;
    overflow: hidden;
  }
  .logo-ring::after {
    content: '';
    position: absolute;
    top: 0; left: -100%;
    width: 60%; height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,193,7,0.18), transparent);
    animation: shimmer 3s infinite;
  }
  @keyframes shimmer {
    0% { left: -100%; }
    60%, 100% { left: 160%; }
  }

  .logo-icon {
    font-size: 32px;
  }

  .header-text h1 {
    font-family: 'Playfair Display', serif;
    font-size: 1.7rem;
    font-weight: 900;
    color: var(--gold);
    letter-spacing: 0.5px;
    line-height: 1.1;
  }
  .header-text p {
    font-size: 0.82rem;
    color: rgba(255,193,7,0.55);
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-top: 3px;
    font-weight: 500;
  }

  .header-badge {
    margin-left: auto;
    background: rgba(255,193,7,0.12);
    border: 1px solid rgba(255,193,7,0.25);
    color: var(--gold);
    font-size: 0.72rem;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    padding: 5px 14px;
    border-radius: 50px;
    font-weight: 600;
  }

  /* ─── MAIN ─── */
  .main {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 48px 20px;
    position: relative;
    z-index: 2;
  }

  .login-card {
    background: var(--white);
    border-radius: var(--radius);
    box-shadow: var(--shadow), 0 2px 0 var(--gold);
    padding: 44px 40px 36px;
    width: 100%;
    max-width: 420px;
    border: 1.5px solid rgba(255,193,7,0.18);
    position: relative;
    animation: cardIn 0.55s cubic-bezier(.22,1,.36,1) both;
  }
  @keyframes cardIn {
    from { opacity: 0; transform: translateY(32px) scale(0.97); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
  }

  .card-accent {
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 4px;
    border-radius: var(--radius) var(--radius) 0 0;
    background: linear-gradient(90deg, var(--gold-deep), var(--gold), #ffe066, var(--gold));
    background-size: 200%;
    animation: gradMove 3s linear infinite;
  }
  @keyframes gradMove {
    0% { background-position: 0%; }
    100% { background-position: 200%; }
  }

  .card-title {
    font-family: 'Playfair Display', serif;
    font-size: 1.55rem;
    font-weight: 700;
    color: var(--dark);
    text-align: center;
    margin-bottom: 4px;
  }
  .card-sub {
    text-align: center;
    font-size: 0.83rem;
    color: var(--text-muted);
    margin-bottom: 30px;
    letter-spacing: 0.5px;
  }

  .form-group {
    margin-bottom: 18px;
  }
  label {
    display: block;
    font-size: 0.78rem;
    font-weight: 600;
    color: var(--dark);
    letter-spacing: 0.8px;
    text-transform: uppercase;
    margin-bottom: 6px;
  }

  .input-wrap {
    position: relative;
    display: flex;
    align-items: center;
  }
  .input-icon {
    position: absolute;
    left: 14px;
    font-size: 1rem;
    pointer-events: none;
    color: var(--text-muted);
  }
  input[type="text"],
  input[type="password"] {
    width: 100%;
    padding: 12px 14px 12px 40px;
    border: 1.5px solid #e9d88a;
    border-radius: 10px;
    font-family: 'DM Sans', sans-serif;
    font-size: 0.95rem;
    color: var(--dark);
    background: var(--gold-pale);
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  }
  input:focus {
    border-color: var(--gold);
    background: #fff;
    box-shadow: 0 0 0 3px rgba(255,193,7,0.14);
  }

  .toggle-pass {
    position: absolute;
    right: 13px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1rem;
    color: var(--text-muted);
    padding: 0;
    transition: color 0.15s;
  }
  .toggle-pass:hover { color: var(--gold-deep); }

  .row-options {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    margin-top: 2px;
  }
  .remember {
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 0.82rem;
    color: var(--text-muted);
    cursor: pointer;
  }
  .remember input[type="checkbox"] {
    accent-color: var(--gold-deep);
    width: 15px; height: 15px;
    cursor: pointer;
  }
  .forgot {
    font-size: 0.82rem;
    color: black;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.15s;
  }
  .forgot:hover { color: var(--dark); }

  .btn-login {
    width: 100%;
    padding: 14px;
    background: linear-gradient(135deg, var(--gold-deep) 0%, var(--gold) 60%, #ffe066 100%);
    border: none;
    border-radius: 10px;
    font-family: 'DM Sans', sans-serif;
    font-size: 1rem;
    font-weight: 700;
    color: var(--dark);
    cursor: pointer;
    letter-spacing: 0.5px;
    box-shadow: 0 4px 18px rgba(255,193,7,0.35);
    transition: transform 0.15s, box-shadow 0.15s, filter 0.15s;
    position: relative;
    overflow: hidden;
  }
  .btn-login::after {
    content: '';
    position: absolute;
    top: 0; left: -100%;
    width: 60%; height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
    transition: left 0.4s;
  }
  .btn-login:hover::after { left: 160%; }
  .btn-login:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 28px rgba(255,193,7,0.45);
    filter: brightness(1.05);
  }
  .btn-login:active { transform: translateY(0); }

  .divider {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 20px 0 0;
  }
  .divider-line { flex: 1; height: 1px; background: #f0dfa0; }
  .divider-text { font-size: 0.75rem; color: #b8a040; font-weight: 500; letter-spacing: 1px; }

  /* ─── FOOTER ─── */
  .footer {
    position: relative;
    z-index: 10;
    background:    linear-gradient(115deg, #242443, #162e29);
    // background: linear-gradient(135deg, var(#242443) 0%, var(#162e29) 60%, var(#162e29) 100%);
    color: rgba(255,255,255,0.7);
    padding: 36px 40px 22px;
    border-top: 2px solid var(--gold);
  }

  .footer-grid {
    display: grid;
    grid-template-columns: 1.4fr 1fr 1.4fr;
    gap: 32px;
    max-width: 900px;
    margin: 0 auto 26px;
  }

  .footer-col h4 {
    font-family: 'Playfair Display', serif;
    font-size: 0.95rem;
    color: var(--gold);
    margin-bottom: 12px;
    letter-spacing: 0.5px;
  }

  .footer-col p, .footer-col a {
    font-size: 0.82rem;
    line-height: 1.7;
    color: rgba(255,255,255,0.6);
    text-decoration: none;
    display: block;
    transition: color 0.15s;
  }
  .footer-col a:hover { color: var(--gold); }

  .portal-link {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    background: rgba(255,193,7,0.1);
    border: 1px solid rgba(255,193,7,0.25);
    color: var(--gold) !important;
    border-radius: 7px;
    padding: 7px 14px;
    font-size: 0.8rem !important;
    font-weight: 600;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
    transition: background 0.2s, border-color 0.2s !important;
  }
  .portal-link:hover {
    background: rgba(255,193,7,0.2) !important;
    border-color: rgba(255,193,7,0.5) !important;
    color: #fff !important;
  }

  .footer-bottom {
    border-top: 1px solid rgba(255,193,7,0.15);
    padding-top: 16px;
    text-align: center;
    font-size: 0.76rem;
    color: rgba(255,255,255,0.3);
    letter-spacing: 0.5px;
  }
  .footer-bottom span { color: var(--gold); }

  /* ─── ALERT ─── */
  .alert {
    border-radius: 9px;
    padding: 10px 14px;
    font-size: 0.82rem;
    margin-bottom: 16px;
    font-weight: 500;
    animation: fadeIn 0.3s;
  }
  @keyframes fadeIn { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; } }
  .alert-error { background: #fff0f0; color: #c0392b; border: 1px solid #fac0c0; }
  .alert-success { background: #fffbe6; color: #7a6000; border: 1px solid var(--gold); }

  @media (max-width: 640px) {
    .header { padding: 18px 18px; gap: 14px; }
    .header-text h1 { font-size: 1.2rem; }
    .header-badge { display: none; }
    .login-card { padding: 32px 22px 26px; }
    .footer { padding: 28px 18px 16px; }
    .footer-grid { grid-template-columns: 1fr; gap: 20px; }
  }
`

export default function HostelLoginPage({ onLogin }) {
  const [showPass, setShowPass] = useState(false)
  const [status, setStatus] = useState(null) // { type, msg }
  const navigate = useNavigate()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [loading1, setLoading1] = useState(false)
  const [loading2, setLoading2] = useState(false)
  const [approvalModal, setApprovalModal] = useState(false)

  const [forgotModal, setForgotModal] = useState(false)
  const [otpModal, setOtpModal] = useState(false)

  const [fpEmail, setFpEmail] = useState('')
  const [fpOtp, setFpOtp] = useState('')
  const [fpNewPass, setFpNewPass] = useState('')
  const [fpConfirmPass, setFpConfirmPass] = useState('')
  const [timer, setTimer] = useState(300) // 5 minutes = 300 sec

  useEffect(() => {
    let interval = null

    if (otpModal) {
      setTimer(300) // reset timer when modal opens

      interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval)

            setOtpModal(false)
            toast.error('OTP expired! Please try again.')

            return 0
          }
          return prev - 1
        })
      }, 1000)
    }

    return () => clearInterval(interval)
  }, [otpModal])

  const handleLogin = async (e) => {
    e.preventDefault()

    if (!username || !password) {
      toast.error('Please enter username and password')
      return
    }

    try {
      setLoading(true)

      const objData = {
        email: username,
        password: password,
      }

      const response = await axios.post(StudentLoginAPI, objData)

      const data = response.data

      if (data == 'INVALID') {
        toast.warn('Invalid credentials!')
      } else if (data == 'NOTFOUND') {
        toast.warn('Data Not Found!')
      } else if (data != null) {
        // ⭐ STATUS CONDITIONS ⭐
        if (data.status === 0) {
          // Not paid hostel fee
          navigate('/student/std-hostelPay')
        } else if (data.status === 1) {
          // Admin approval pending
          // Show Modal Instead of Navigation
          setApprovalModal(true)
        } else if (data.status === 2) {
          // Approved Student
          toast.success('Login successful')
          navigate('/student/std-dashboard')
        } else if (data.status === 3) {
          // Rejected hostel fee
          navigate('/student/std-hostelPay')
        }

        sessionStorage.setItem('studentData', JSON.stringify(data))
        sessionStorage.setItem('username', 'student')
        onLogin('student')
      }
    } catch (error) {
      toast.error('Something went wrong!')
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  // SEND OTP
  const sendOtpHandler = async () => {
    if (!fpEmail) {
      toast.error('Please enter email!')
      return
    }

    try {
      setLoading1(true)

      const response = await axios.post(SendUserOtp, { email: fpEmail })

      if (response.data === 'SENDOTP') {
        toast.success('OTP sent successfully!')
        setForgotModal(false)
        setOtpModal(true)
      } else if (response.data === 'NOTFOUND') {
        toast.error('Email not found!')
      }
    } catch (err) {
      toast.error('Failed to send OTP')
    } finally {
      setLoading1(false)
    }
  }

  // VERIFY OTP + RESET PASSWORD
  const verifyOtpHandler = async () => {
    if (!fpOtp || !fpNewPass) {
      toast.error('All fields are required!')
      return
    }

    try {
      setLoading2(true)

      const response = await axios.post(ResetPassword, {
        email: fpEmail,
        otp: fpOtp,
        newPassword: fpNewPass,
      })

      if (response.data === 'PASSWORDCHANGED') {
        toast.success('Password reset successfully!')
        setOtpModal(false)
      } else if (response.data === 'INVALIDOTP') {
        toast.warn('Invalid OTP!')
      } else if (response.data === 'EXPIRYOTP') {
        toast.warn('OTP has been expired!')
      } else if (response.data === 'NOTFOUND') {
        toast.warn('Member not found!')
      } else {
        toast.error('Invalid OTP or error resetting password!')
      }
    } catch (err) {
      toast.error('Something went wrong!')
    } finally {
      setLoading2(false)
    }
  }

  return (
    <>
      <style>{style}</style>
      <div className="page">
        {/* ── HEADER ── */}
        <header className="header py-3 px-2 px-md-3">
          <div className="logo-ring">
            <span className="logo-icon">🏛️</span>
          </div>
          <div className="header-text">
            <h1>Digambar Jain Boarding, Kolhapur</h1>
            <p>Student Hostel &amp; Accommodation</p>
          </div>
          <span className="header-badge">Est. 1905</span>
        </header>

        {/* ── MAIN ── */}
        <main className="main">
          <div className="login-card">
            <div className="card-accent" />

            <h2 className="card-title">Student Login</h2>
            <p className="card-sub">Access your hostel portal account</p>

            {status && (
              <div className={`alert alert-${status.type}`}>
                {status.type === 'error' ? '⚠️' : '✅'} {status.msg}
              </div>
            )}

            <form onSubmit={handleLogin} autoComplete="off">
              <div className="form-group">
                <label htmlFor="username">Username</label>
                <div className="input-wrap">
                  <span className="input-icon">👤</span>
                  <input
                    id="username"
                    type="text"
                    placeholder="Enter your username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <div className="input-wrap">
                  <span className="input-icon">🔒</span>
                  <input
                    id="password"
                    type={showPass ? 'text' : 'password'}
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="toggle-pass"
                    onClick={() => setShowPass((v) => !v)}
                    aria-label="Toggle password"
                  >
                    {showPass ? '🙈' : '👁️'}
                  </button>
                </div>
              </div>

              <div className="row-options text-end">
                <a href="#/student/reg-TermsConditions" className="forgot">
                  New User? Register Here
                </a>
                <a
                  href="#"
                  className="forgot"
                  onClick={(e) => {
                    e.preventDefault() // prevents page jump
                    setForgotModal(true) // open modal
                  }}
                >
                  Forgot password?
                </a>
              </div>

              <button className="btn-login" type="submit" disabled={loading}>
                {loading ? 'Signing in…' : 'Sign In →'}
              </button>
            </form>

            {/* <div className="divider">
              <div className="divider-line" />
              <span className="divider-text">SECURE PORTAL</span>
              <div className="divider-line" />
            </div> */}
          </div>
        </main>

        {/* ── FOOTER ── */}
        <footer className="footer">
          <div className="footer-grid">
            <div className="footer-col">
              <h4>🏛️ Digambar Jain Boarding, Kolhapur</h4>
              <p>
                Providing safe, comfortable &amp; affordable accommodation to
                students since 1905. Your home away from home.
              </p>
            </div>

            <div className="footer-col">
              <h4>🔐 Staff Portals</h4>
              <a href="#/admin/login" className="portal-link">
                ⚙️ Admin Login
              </a>
              <a href="#/alumni/login" className="portal-link">
                ⚙️ Alumni Login
              </a>
            </div>

            {/* 8412841008, 0231 2644339 */}
            {/* djbkkop@gmail.com */}
            <div className="footer-col">
              <h4>📍 Contact Us</h4>
              <p>📞 +91 8412841008, 0231-2644339</p>
              <a href="mailto:djbkkop@gmail.com">
                ✉️ djbkkop@gmail.com
              </a>
              <p style={{ marginTop: '6px' }}>
                🏠 Near, Dasara Chowk, New Shahupuri,
                <br />
                Kolhapur, Maharashtra 416002
              </p>
            </div>
          </div>

          <div className="footer-bottom">
            © {new Date().getFullYear()}{' '}
            <span>Digambar Jain Boarding, Kolhapur</span>. All rights reserved.
            &nbsp;|&nbsp; Designed by TechnoAarv Solution.
          </div>
        </footer>

        <Modal
          title={
            <span
              style={{
                fontSize: '22px',
                fontWeight: '600',
                color: '#235784',
              }}
            >
              Waiting for Admin Approval <br />
            </span>
          }
          className="approval-modal"
          open={approvalModal}
          onOk={() => setApprovalModal(false)}
          okText="OK"
          closable={false}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <p style={{ fontSize: '18px' }}>
            Your registration is under verification.
          </p>
          <p style={{ fontSize: '18px' }}>
            Please wait until admin approves your account.
          </p>
        </Modal>

        {/* ================== FORGOT PASSWORD – EMAIL MODAL ================== */}
        <Modal
          title={
            <span
              style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#235784',
              }}
            >
              Forgot Password
            </span>
          }
          open={forgotModal}
          onCancel={() => setForgotModal(false)}
          footer={null}
        >
          <label style={{ fontSize: '16px' }}>Enter Registered Email</label>
          <input
            type="email"
            value={fpEmail}
            onChange={(e) => setFpEmail(e.target.value)}
            placeholder="Enter email"
            className="form-control"
            style={{ marginTop: '8px', borderRadius: '6px' }}
          />

          <button
            className="btn-login"
            style={{ width: '100%', marginTop: '15px' }}
            onClick={sendOtpHandler}
            disabled={loading1}
          >
            {loading1 ? 'Wait...' : 'Send OTP'}
          </button>
        </Modal>

        {/* ================== OTP + NEW PASSWORD MODAL ================== */}
        <Modal
          title={
            <span
              style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#235784',
              }}
            >
              Reset Password
            </span>
          }
          open={otpModal}
          onCancel={() => setOtpModal(false)}
          footer={null}
        >
          <label style={{ fontSize: '16px' }}>Enter OTP</label>
          <input
            type="text"
            className="form-control"
            value={fpOtp}
            onChange={(e) => setFpOtp(e.target.value)}
            placeholder="Enter OTP"
            style={{
              marginBottom: '10px',
              marginTop: '5px',
              borderRadius: '6px',
            }}
          />
          <p style={{ color: 'red', fontWeight: '500' }}>
            Time Remaining: {Math.floor(timer / 60)}:
            {timer % 60 < 10 ? `0${timer % 60}` : timer % 60}
          </p>

          <label style={{ fontSize: '16px' }}>New Password</label>
          <input
            type="password"
            className="form-control"
            value={fpNewPass}
            onChange={(e) => setFpNewPass(e.target.value)}
            placeholder="New Password"
            style={{
              marginBottom: '10px',
              marginTop: '5px',
              borderRadius: '6px',
            }}
          />

          <button
            className="btn-login"
            style={{ width: '100%', marginTop: '15px' }}
            onClick={verifyOtpHandler}
          >
            {loading2 ? 'Wait...' : 'Reset Password'}
          </button>
        </Modal>
      </div>
    </>
  )
}
